module.exports = __webpack_public_path__ + "static/media/decor.94d14163.png";